import { render } from "./who_to_follow.vue?vue&type=template&id=1d38a2c8"
import script from "./who_to_follow.js?vue&type=script&lang=js"
export * from "./who_to_follow.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__